import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanMatchFn, Router, UrlSegment, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

// Regel trifft das Backend (appAccess); hier nur zentral ausgewertet

export function mayUseCrm(authService: AuthService): boolean {
  return authService.getAppAccess().includes('crm');
}

export function mayUseStudentView(authService: AuthService): boolean {
  return authService.getAppAccess().includes('student');
}

export const accessErrorUrl = '/access-error';

/** CRM hat Vorrang */
export function homeUrl(authService: AuthService): string {
  if (mayUseCrm(authService)) return '/dashboard';
  if (mayUseStudentView(authService)) return '/student';
  return '/login';
}

export const crmGuard: CanMatchFn = (_route, segments) =>
  guardView(segments, mayUseCrm);

export const studentViewGuard: CanMatchFn = (_route, segments) =>
  guardView(segments, mayUseStudentView);

function guardView(
  segments: UrlSegment[],
  mayUse: (authService: AuthService) => boolean,
): boolean | UrlTree {
  // SSR: kein Token, Browser entscheidet
  if (!isPlatformBrowser(inject(PLATFORM_ID))) return true;

  const authService = inject(AuthService);
  const router = inject(Router);

  const returnUrl = '/' + segments.map((segment) => segment.path).join('/');
  const returnUrlParams = { queryParams: returnUrl === '/' ? {} : { returnUrl } };

  if (!authService.isLoggedIn()) {
    return router.createUrlTree(['/login'], returnUrlParams);
  }
  // sonst stillschweigend leere Oberfläche
  if (!authService.isAccessLoaded()) {
    return router.createUrlTree([accessErrorUrl], returnUrlParams);
  }

  return mayUse(authService) ? true : router.parseUrl(homeUrl(authService));
}

/** nur App-interne Pfade (kein //host) */
export function safeReturnUrl(returnUrl: string | null): string | null {
  return returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//')
    ? returnUrl
    : null;
}
